(function () {
 'use strict';
 function init() {
  document.querySelectorAll('[data-nq-device-showcase]').forEach(function (stage) {
   if (stage.dataset.motionReady) return;
   stage.dataset.motionReady = 'true';
   var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
   var buttons = stage.querySelectorAll('[data-nq-theme]');
   var paused = reduced.matches, visible = false, timer;
   function theme(value) {
    stage.dataset.theme = value;
    buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.nqTheme === value)); });
    stage.querySelectorAll('.nq-device-light').forEach(function (img) { img.setAttribute('aria-hidden', String(value !== 'light')); });
    stage.querySelectorAll('.nq-device-dark').forEach(function (img) { img.setAttribute('aria-hidden', String(value !== 'dark')); });
    stage.querySelectorAll('[data-nq-tablet-link], [data-nq-phone-link]').forEach(function (deviceLink) {
     deviceLink.href = deviceLink.querySelector(value === 'dark' ? '.nq-device-dark' : '.nq-device-light').src;
    });
   }
   function schedule() {
    clearInterval(timer);
    stage.dataset.paused = String(paused);
    if (!paused && visible && !document.hidden && !reduced.matches) timer = setTimeout(function () { theme(stage.dataset.theme === 'light' ? 'dark' : 'light'); paused = true; schedule(); }, 3500);
   }
   buttons.forEach(function (button) { button.addEventListener('click', function () { paused = true; theme(button.dataset.nqTheme); schedule(); }); });
   new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; stage.dataset.inview = String(visible); schedule(); }, {threshold: .15}).observe(stage);
   document.addEventListener('visibilitychange', schedule);
   reduced.addEventListener('change', function () { paused = reduced.matches; schedule(); });
   schedule();
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
